import React from 'react';
import Portal from 'react-portal';

import classnames from 'classnames';

import {hasScrollBar, scrollBarWidth, setBackgroundScrollable} from '../../util/scroll';

const POS_STYLE = {
  top: {top: 0},
  bottom: {bottom: 0},
  left: {left: 0},
  right: {right: 0},
};

const FLUID_STYE = {
  top: {width: '100vw'},
  bottom: {width: '100vw'},
  left: {height: '100vh'},
  right: {height: '100vh'},
};

export default class PageOverlay extends React.Component {
  componentWillReceiveProps(next) {
    // Disable scroll and add padding in place of scrollbar
    if (this.props.disableScrolling) {
      if (this.props.active && !next.active) {
        setBackgroundScrollable(true, {fixed: this.props.lockScrolling});
      }
      if (!this.props.active && next.active && hasScrollBar()) {
        setBackgroundScrollable(false, {fixed: this.props.lockScrolling});
      }
    }
  }

  animate(node, open, cb) {
    let duration = this.props.animationDuration;
    let anchor = this.props.anchor;
    let dimension = Object.keys(FLUID_STYE[anchor])[0] === 'width' ? 'height' : 'width';
    let animateInterval = window.requestAnimationFrame || window.mozRequestAnimationFrame;
    if (animateInterval && node.getBoundingClientRect && node.style) {
      let min = -node.getBoundingClientRect()[dimension];
      let max = parseInt(node.style[anchor]);
      let start, end;
      function step(timestamp) {
        if (!start) {
          start = timestamp;
          end = start + duration;
        }
        let progress;
        if (timestamp < end) {
          progress = (timestamp - start) / (end - start);
        } else {
          progress = 1;
        }
        let value;
        if (open) {
          value = min + (max - min) * progress;
        } else {
          value = max - (max - min) * progress;
        }
        node.style[anchor] = `${value}px`;

        if (timestamp < end) {
          animateInterval(step);
        } else {
          cb();
        }
      }
      animateInterval(step);
    } else {
      cb();
    }
  }

  animateOnOpen(node) {
    this.animate(node, true, i => i);
  }


  animateBeforeClose(node, cb) {
    this.animate(node, false, cb);
  }

  render() {
    let animated = POS_STYLE[this.props.anchor] && this.props.animationDuration > 0;
    return (
      <Portal
        onClose={(this.props.active && this.props.onDeactivate) || (n => n)}
        className={classnames('PageOverlay', this.props.className)}
        isOpened={this.props.active || false}
        beforeClose={(animated && this.animateBeforeClose.bind(this)) || false}
        onOpen={(animated && this.animateOnOpen.bind(this)) || (n => n)}
        style={Object.assign({position: 'fixed', zIndex: this.props.zIndex || '99999'}, POS_STYLE[this.props.anchor], this.props.fluid && FLUID_STYE[this.props.anchor], this.props.style)}
        closeOnOutsideClick={this.props.closeOnOutsideClick}
      >
        {this.props.children}
      </Portal>
    );
  }
}



// WEBPACK FOOTER //
// ./~/sp-components/components/PageOverlay/index.jsx